<!-- The bar is free-dragged rather than repositioned by CSS: its wrapper anchors
     it to the bottom centre of the map, and cdkDrag's transform moves it from
     there without that wrapper (shared with every other in-map overlay) having
     to know anything about it. `cdkDragBoundary` is what keeps it inside the
     map — the offset is clamped to the Leaflet container's own rect, so the bar
     cannot be lost behind the sidebar or off the bottom of the page. -->
<div class="tb-host" [class.tb-host--dark]="dark" appLeafletStopPropagation
     cdkDrag
     [cdkDragBoundary]="dragBoundary"
     [cdkDragFreeDragPosition]="drag.position"
     (cdkDragStarted)="onDragStarted()"
     (cdkDragEnded)="onDragEnded($event)">
  <!-- Leftmost, before every control: a grip that sat among the buttons would
       read as one. Not focusable — dragging is a pointer gesture, and a tab stop
       that does nothing on Enter is noise in a bar the keyboard already walks. -->
  <!-- Tooltip disabled for the duration of the drag: the overlay is anchored to
       the grip, so it would otherwise ride along under the cursor and cover the
       map the user is dragging the bar across. Setting `disabled` also hides an
       already-open tooltip, so no explicit hide() is needed. -->
  <span class="tb-grip" cdkDragHandle
        (dblclick)="resetPosition()"
        matTooltip="Drag to move the toolbar · double-click to reset"
        [matTooltipDisabled]="dragging"
        matTooltipPosition="above">
    <mat-icon class="material-icons-outlined">drag_indicator</mat-icon>
  </span>

  <ng-container *ngFor="let c of resolved">
    <ng-container *ngComponentOutlet="c.component; injector: c.injector"></ng-container>
  </ng-container>
</div>
